import Cookies from 'js-cookie';

export default {
    replaceUrlParam: (url: string, paramName: string, paramValue: string | null): string => {
        if (paramValue == null) {
            paramValue = '';
        }
        var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
        if (url.search(pattern) >= 0) {
            return url.replace(pattern, '$1' + paramValue + '$2');
        }

        return url;
    },
    replaceOrAddUrlParam: (url: string, paramName: string, paramValue: string | null): string => {
        if (paramValue == null) {
            paramValue = '';
        }
        var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
        if (url.search(pattern) >= 0) {
            return url.replace(pattern, '$1' + paramValue + '$2');
        }
        url = url.replace(/[?#]$/, '');
        return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
    },
    checkVisible(elem: HTMLElement): boolean {
        var rect = elem.getBoundingClientRect();
        var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    },
    doSomethingOnceVisible: function (elem: HTMLElement, handler: () => void): void {
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        observer.unobserve(entry.target);
                        handler();
                    }
                });
            }, { root: null, threshold: 0 });
        observer.observe(elem);
    },
    isNull(val: unknown): boolean {
        return (val == null || typeof val === 'undefined');
    },
    hasValue(val: unknown): boolean {
        return val != null && typeof val !== 'undefined';
    },
    getAffiliateParams(siteName: string): { amazonTag: string; sharedid: string } {
        const cookie_lastref = Cookies.get("MMD_LastRef");

        // Default values
        let tag = 'mommydeals0a-20';
        let sharedid = 'mommydeals';

        // Define conditions for each site and cookie reference
        if (cookie_lastref && cookie_lastref.toLowerCase() === '5townscentral') {
            tag = '5townscentral-20';
        }
        else if (siteName === 'alyssagoldwater' || (cookie_lastref && cookie_lastref.toLowerCase() === 'alyssagoldwater')) {
            tag = 'agoldwater-20';
        }
        else if (cookie_lastref && cookie_lastref.toLowerCase() === 'mmdfriedman') {
            tag = 'mmdfriedman-20';
            sharedid = 'moshe';
        }
        else if (cookie_lastref && cookie_lastref.toLowerCase() === 'klugman') {
            tag = '18ventures-20';
            sharedid = 'klugman';
        }
        else if (cookie_lastref && cookie_lastref.toLowerCase() === 'dovidklugman') {
            tag = 'mmdbraum-20';
            sharedid = 'dovidklugman';
        }
        else if (cookie_lastref && cookie_lastref.toLowerCase() === 'braum') {
            tag = 'mmdbraum-20';
            sharedid = 'braum';
        }
        else if (cookie_lastref && cookie_lastref.toLowerCase() === 'tempelberg') {
            tag = 'tempelberg-20';
            sharedid = 'tempelberg';
        }
        else if (siteName === '5tcdeals') {
            tag = '5townscentral-20';
            sharedid = '5tcdeals';
        }
        else if (siteName === 'mommydeals') {
            tag = 'mommydeals0a-20';
            sharedid = 'mommydeals';
        }
        else if (siteName === 'petpetdeals') {
            tag = 'petpetdeals-20';
            sharedid = 'petpetdeals';
        }
        else if (siteName === 'chaideals') {
            tag = 'chaideals-20';
            sharedid = 'chaideals';
        }

        return { amazonTag: tag, sharedid };
    },


    getDiscountPercentage(dealPrice: number | null, retailPrice: number | null): number | null 
    {
        if (dealPrice && retailPrice) {
            return ((retailPrice - dealPrice) / retailPrice) * 100
        }
        return null;
    },

    async shareLink(url: string, title: string = 'Check out this link!', text: string = 'Found this on MommyDeals – thought you’d like it.'){
        if (navigator.share) {
            try {
              await navigator.share({
                title: title,
                text: text,
                url: url,
              });
            } catch (err) {
              console.error('Share canceled or failed', err);
            }
          } else {
            navigator.clipboard.writeText(url)
          }
    },

    showToast(
        message: string,
        options?: {
          icon?: string;
          iconClass?: string;
          duration?: number;
        }
      ) {
        const toast = document.createElement('div');
        toast.className = 'global-toast';
      
        const iconHtml = options?.icon
          ? `<span class="material-symbols-outlined toast-icon ${options.iconClass ?? ''}">${options.icon}</span>`
          : '';
      
        toast.innerHTML = `${iconHtml}<span>${message}</span>`;
      
        document.body.appendChild(toast);
        void toast.offsetHeight;
        toast.classList.add('show');
      
        const duration = options?.duration ?? 2000;
        setTimeout(() => {
          toast.classList.remove('show');
          toast.addEventListener('transitionend', () => {
            toast.remove();
          });
        }, duration);
      },
      debounce<T extends (...args: any[]) => void>(method: T, delay: number, ...args: Parameters<T>) {
        if ((method as any)._tId !== null) {
            clearTimeout((method as any)._tId);
            (method as any)._tId = null;
        }
    
        (method as any)._tId = setTimeout(function () {
            // method.apply(null, args);
            method(...args);
        }, delay);
    },
    isAllowedChar(char: string): boolean {
        const allowedChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 .,;:?!\"'()[]{}<>/\\|@#$%^&*-_+=";
        return allowedChars.includes(char);
      },
      
      makeSingleLine(str: string): string {
        return str.replace(/\n/g, " | ");
      },
      
      addSpaceAroundSpecialPatterns(text: string): string {
        // Add space around dollar amounts if prefixed/suffixed by commas, periods, parentheses, or spaces
        text = text.replace(/([,.()]\s*)?(\$[\d.]+)(\s*[,.()])?/g, (match, prefix, amount, suffix) => {
          const spaceBefore = prefix ? prefix.trim() + ' ' : '';
          const spaceAfter = suffix ? ' ' + suffix.trim() : '';
          return `${spaceBefore}${amount}${spaceAfter}`;
        });
      
        // Add space around percentages if prefixed/suffixed by commas, periods, parentheses, or spaces
        text = text.replace(/([,.()]\s*)(\d+%)/g, '$1 $2');
        text = text.replace(/(\d+%)(\s*[,.()])/g, '$1 $2');

        // add space around any colons even if its in the middle of a word
        text = text.replace(/(https?):\/\/|[:：]/g, (match, protocol) => {
          return protocol ? `${protocol}://` : ' : ';
        });
      
        return text;
      },
      
      clean(str: string): string {
        // Remove multi lines
        const singleLineString = this.makeSingleLine(str);
        const clearedUpString = this.addSpaceAroundSpecialPatterns(singleLineString);
      
        const finalString = clearedUpString;
        console.log(finalString);
      
        let filteredText = "";
        for (let i = 0; i < finalString.length; i++) {
          if (this.isAllowedChar(finalString[i])) {
            filteredText += finalString[i];
          }
        }
      
        // Then, replace sequences of two or more spaces with a single space
        const cleanedText = filteredText.replace(/ {2,}/g, ' ');
        return cleanedText;
      },
      
      cleanText(str: string): string {
        return this.clean(str);
      }
    

}
